// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { useEffect, useState } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useAppDispatch } from 'Hooks';
import { getAllFoldersThunk } from 'Features/folderList/folderListThunk';

// Folders come from the folders endpoint rather than riding along on a projects response: the
// whole organisation's folders, which is what the badge on a project card needs to resolve.
// Answers whether the request has settled - until then "no folders" means "not known yet",
// not "none", and claiming the account has none before then would flash a wrong answer on
// every load.
export const useDashboardFolders = (): { foldersAnswered: boolean } => {
  const dispatch = useAppDispatch();
  const [foldersAnswered, setFoldersAnswered] = useState(false);

  useEffect(() => {
    const loadFolders = async () => {
      try {
        await dispatch(getAllFoldersThunk());
      } catch (error) {
        // Projects are the page; folders decorate it. A failure here costs the Folders section
        // and the cards' badges, and must not take the project list down with it.
        datadogRum.addError(error);
      } finally {
        setFoldersAnswered(true);
      }
    };
    loadFolders();
  }, []);

  return { foldersAnswered };
};

export default useDashboardFolders;
